import { API_ROOT } from '../../config/config'

import { doGet, doPost, doPut } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getProjectName = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project-name`
  return doGet(url)
}

export const saveProjectName = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project-name`
  return doPost(url, request)
}

export const updateProjectName = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project-name/${request.id}`
  return doPut(url, request)
}

// ---------------------------------- subproject

export const getSubProjectName = (id) => {
  const url = `${API_ROOT}/subproject/${id}/project-name`
  return doGet(url)
}

export const saveSubProjectName = (id, request) => {
  const url = `${API_ROOT}/subproject/${id}/project-name`
  return doPost(url, request)
}

export const updateSubProjectName = (id, request) => {
  const url = `${API_ROOT}/subproject/${id}/project-name/${request.id}`
  return doPut(url, request)
}

// ----------------------------------
